module.exports = (__webpack_require__(7))(446);


//////////////////
// WEBPACK FOOTER
// delegated ./src/main/webapp/app/vendor.ts from dll-reference vendor
// module id = 455
// module chunks = 0